import { render, staticRenderFns } from "./ElementBoxIcon.vue?vue&type=template&id=02b60f34&"
import script from "./ElementBoxIcon.vue?vue&type=script&lang=js&"
export * from "./ElementBoxIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports